import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import './../css/footer.css';

import ENewsForm from './footer/ENewsForm';

// import imgMercury from './../images/logos/mercurycart.png'
// import imgGeotrust from './../images/logos/geotrust.png'
// import imgCompany from './../images/logos/spits-logo-sm.png'
// import imgCrease from './../images/logos/crease.png'

class Footer extends Component {
	showSocial() {
		if (this.props.siteInfo.isLoading) {
			return null;
		} else {
			return (
				<div className="social_nav">
					{/* {this.props.siteInfo.social.map(function(item, i) {
						return (
							<a
								key={i}
								className={`nav_item icon-${item.social_media_type}-square`}
								href={item.url}
								target="_blank"
								rel="noopener noreferrer"
							>
								<span>Go to {item.social_media_type}</span>
							</a>
						);
					})} */}
					<a
						className="nav_item icon-mail"
						href="mailto:info@muscederevineyards.com"
						target="_blank"
						rel="noopener noreferrer"
						alt=""
					/>
					<a
						className="nav_item icon-facebook"
						href="https://www.facebook.com/MuscedereVineyards"
						target="_blank"
						rel="noopener noreferrer"
						alt=""
					/>
					<a
						className="nav_item icon-instagram"
						href="https://www.instagram.com/muscederevineyards"
						target="_blank"
						rel="noopener noreferrer"
						alt=""
					/>
				</div>
			);
		}
	}

	showPages() {
		if (this.props.siteInfo.isLoading) {
			return null;
		} else {
			return (
				<nav>
					<ul className="footer_nav">
						{this.props.siteInfo.content_pages.map(function(item, i) {
							return (
								<li key={i}>
									<Link to={`/${item.permalink}`}>{item.title}</Link>
								</li>
							);
						})}
					</ul>
				</nav>
			);
		}
	}

	render() {
		// console.log('public url: ', process.env)
		let currentYear = new Date().getFullYear;

		return (
			<footer>
				<div className="body_container">
					<div className="footer_promo">
						<Link className="dm_logo" to="/">
							<img
								src={`/images/logos/mercurycart.png`}
								alt="MercuryCart Powered By Digital Media"
							/>
							{/* <img src={imgMercury} alt="MercuryCart Powered By Digital Media" /> */}
						</Link>
					</div>

					<div className="footer_content">
						<div className="form_section">
							<div className="hbs-enews">
								<ENewsForm />
							</div>

							<div className="promo_section">
								<a
									href="https://www.geotrust.com/"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img src={`/images/logos/geotrust.png`} alt="GeoTrust" />
								</a>
							</div>
						</div>
						<div className="nav_section">
							{this.showPages()}

							<div className="copyright">
								Copyright &copy; Muscedere Vineyards Estate Winery Inc. {new Date().getFullYear()}
							</div>

							{this.showSocial()}
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

export default connect((state) => ({
	siteInfo: state.siteInfo,
}))(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js